import { ApiResponse, RefreshResponseData } from '../models/apiResponse';
import { apiRequests as requests } from './http-client';

const Auth = {
  refresh: () =>
    requests
      .post<ApiResponse<RefreshResponseData>>('/v1/refresh', {})
      .then((authResponse) => ({
        accessToken: authResponse.data?.token,
        refreshToken: authResponse.data?.refresh_token,
      })),
};

export default Auth;
